import backendURLs from '~/misc/backendURLs';

export default (axios, params) => {
  return axios
    .get(`${backendURLs.statistics}/products/latest`, { params })
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));
};
